import AboutInfo from '../About/AboutInfo'
import Background from '../Background/Background'
import Experience from '../Experience/Experience'
import Hero from '../Hero/Hero'

const Home = () => {
  return (
    <>
      <Background />
      <Hero />
      <Experience />
      <AboutInfo />
      {/* <ProjectsContainer /> */}
    </>
  )
}

export default Home
